import React from 'react';
import { Container, Stack, Toolbar } from '@mui/material';
import { Header } from '@shared/components/Header';




export const MainLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <React.Fragment>
      <Header />
      <Container maxWidth={false} disableGutters sx={{ height: '100dvh' }}>
        <Stack height="100%" direction="row">
          <Stack component="main" width="100%" height="100%">
            <Toolbar />
            {children}
          </Stack>
        </Stack>
      </Container>
    </React.Fragment>
  );
};
